import React, {useState} from "react";
import {useObserver} from "mobx-react-lite";
import {useTranslation} from "react-i18next";
import {Col, Row, Table, Tabs} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {CustomButton} from "../_defaultComponents/CustomButton/CustomButton";
import {EmptyMessage} from "../_defaultComponents/EmptyMessage/EmptyMessage";
import ZoneManagement from "./ZoneManagement/ZoneManagement";
import Zone from "./Zone/Zone";

const OperationOrganization = () => {
    const {TabPane} = Tabs;

    const [activeKey, setActiveKey] = useState("zone");
    const {t} = useTranslation(["common"]);

    const changeTab = value => {
        setActiveKey(value);
    };

    // Şimdilik boş data - Bölgeler sekmesi için
    const regions = [];

    return useObserver(() => (
        <React.Fragment>
            <Row type="flex" style={{width: "100%"}}>
                <Tabs activeKey={activeKey} onChange={changeTab} style={{width: "100%"}}>
                    <TabPane tab="Bölge Müdürlükleri" key="zoneManagement">
                        <ZoneManagement isActive={activeKey === "zoneManagement"} />
                    </TabPane>
                    <TabPane tab="Bölgeler" key="zone">
                        <Zone isActive={activeKey === "zone"} />
                    </TabPane>
                </Tabs>
            </Row>
        </React.Fragment>
    ));
};

export default OperationOrganization;
